import { cn } from "@/lib/utils";
import type { DocumentStatus } from "../types.js";

const STATUS_STYLES: Record<
  DocumentStatus | "private" | "public" | "organization" | "owner" | "admin" | "member" | "viewer" | "planned",
  string
> = {
  private: "bg-[var(--tint-purple-bg)] text-[var(--tint-purple-fg)] dark:bg-violet-500/15 dark:text-violet-300",
  public: "bg-[var(--tint-blue-bg)] text-[var(--tint-blue-fg)] dark:bg-sky-500/15 dark:text-sky-300",
  organization: "bg-[var(--tint-blue-bg)] text-[var(--tint-blue-fg)] dark:bg-indigo-500/15 dark:text-indigo-300",
  owner: "bg-[var(--tint-purple-bg)] text-[var(--tint-purple-fg)] dark:bg-violet-500/15 dark:text-violet-300",
  admin: "bg-[var(--tint-amber-bg)] text-[var(--tint-amber-fg)] dark:bg-amber-500/15 dark:text-amber-300",
  member: "bg-[var(--tint-green-bg)] text-[var(--tint-green-fg)] dark:bg-emerald-500/15 dark:text-emerald-300",
  viewer: "bg-[#f1f3f7] text-[#576274] dark:bg-slate-500/15 dark:text-slate-300",
  completed: "bg-[var(--tint-green-bg)] text-[var(--tint-green-fg)] dark:bg-emerald-500/15 dark:text-emerald-300",
  processing: "bg-[var(--tint-amber-bg)] text-[var(--tint-amber-fg)] dark:bg-yellow-500/15 dark:text-yellow-300",
  pending: "bg-[var(--tint-blue-bg)] text-[var(--tint-blue-fg)] dark:bg-blue-500/15 dark:text-blue-300",
  failed: "bg-[var(--tint-red-bg)] text-[var(--tint-red-fg)] dark:bg-red-500/15 dark:text-red-300",
  planned: "bg-[var(--tint-blue-bg)] text-[var(--tint-blue-fg)] border border-[rgba(29,78,216,0.2)] dark:bg-blue-500/12 dark:text-blue-300 dark:border-blue-500/25",
};

interface RagBadgeProps {
  variant: keyof typeof STATUS_STYLES;
  children: React.ReactNode;
  className?: string;
}

export function RagBadge({ variant, children, className }: RagBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium",
        STATUS_STYLES[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
